'use client'

import { useEffect } from 'react'

import { endCaptureIfLoaded } from './navigate'

/**
 * Mounted in the public layout: any soft navigation that lands here while Heap
 * is loaded (cross-tab sign-out, refresh failure, Back after login) becomes a
 * full page load, since Heap keeps capturing via pushState.
 */
export function EndCapture() {
  useEffect(() => {
    endCaptureIfLoaded()
  }, [])
  return null
}
